module.exports = __webpack_public_path__ + "img/students-walking-fall.9cd06d73.jpg";